import { handleActions } from 'redux-actions';
import {
    getTenantProfile, getTenantProfileSuccess, getTenantProfileFail,
    getPublicTenantProfile, getPublicTenantProfileSuccess, getPublicTenantProfileFail,
    saveTenantProfile, saveTenantProfileSuccess, saveTenantProfileFail,
    revokeProfileSlugSuccess, revokeProfileSlugFail,
    regenerateProfileSlugSuccess, regenerateProfileSlugFail,
    clearPublicProfile
} from '../actions/tenantProfile';
import { TenantProfileState } from '../types/tenantProfile';
import { Action } from './types';

const initialState: TenantProfileState = {
    ownProfile: null,
    publicProfile: null,
    isLoading: false,
    isSaving: false,
    error: null
};

const tenantProfile = handleActions<TenantProfileState, any>({
    // GET own profile
    [getTenantProfile]: (state) => ({
        ...state,
        isLoading: true,
        error: null
    }),
    [getTenantProfileSuccess]: (state, { payload }: Action) => ({
        ...state,
        isLoading: false,
        ownProfile: payload
    }),
    [getTenantProfileFail]: (state, { payload }: Action<string>) => ({
        ...state,
        isLoading: false,
        error: payload
    }),

    // GET public profile
    [getPublicTenantProfile]: (state) => ({
        ...state,
        isLoading: true,
        error: null,
        publicProfile: null
    }),
    [getPublicTenantProfileSuccess]: (state, { payload }: Action) => ({
        ...state,
        isLoading: false,
        publicProfile: payload
    }),
    [getPublicTenantProfileFail]: (state, { payload }: Action<string>) => ({
        ...state,
        isLoading: false,
        error: payload
    }),

    // SAVE profile
    [saveTenantProfile]: (state) => ({
        ...state,
        isSaving: true,
        error: null
    }),
    [saveTenantProfileSuccess]: (state, { payload }: Action) => ({
        ...state,
        isSaving: false,
        ownProfile: payload
    }),
    [saveTenantProfileFail]: (state, { payload }: Action<string>) => ({
        ...state,
        isSaving: false,
        error: payload
    }),

    // REVOKE slug
    [revokeProfileSlugSuccess]: (state) => ({
        ...state,
        ownProfile: state.ownProfile
            ? { ...state.ownProfile, isActive: false }
            : null
    }),
    [revokeProfileSlugFail]: (state, { payload }: Action<string>) => ({
        ...state,
        error: payload
    }),

    // REGENERATE slug
    [regenerateProfileSlugSuccess]: (state, { payload }: Action<{ slug: string }>) => ({
        ...state,
        ownProfile: state.ownProfile
            ? { ...state.ownProfile, slug: payload.slug, isActive: true }
            : null
    }),
    [regenerateProfileSlugFail]: (state, { payload }: Action<string>) => ({
        ...state,
        error: payload
    }),

    // CLEAR public profile on unmount
    [clearPublicProfile]: (state) => ({
        ...state,
        publicProfile: null,
        error: null
    })
}, initialState);

export default tenantProfile;
